import { render, staticRenderFns } from "./aboveall.vue?vue&type=template&id=5278db12&"
import script from "./aboveall.vue?vue&type=script&lang=js&"
export * from "./aboveall.vue?vue&type=script&lang=js&"
import style0 from "./aboveall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports